import React from "react";
import { FiFacebook, FiInstagram, FiTwitch, FiYoutube } from "react-icons/fi";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";

const Footer = () => {
  return (
    <div className="p-5 lg:px-10 bg-white py-10">
      <div className="flex flex-col md:flex-row justify-between w-[90%] mx-auto">
        <div className="flex flex-col gap-3 w-full mb-5 md:mb-0 md:w-1/4">
          <h2 className="tracking-wider mb-4 text-xl">Quick Links</h2>
          <p className="text-gray-500 cursor-pointer">Dress</p>
          <p className="text-gray-500 cursor-pointer">Top</p>
          <p className="text-gray-500 cursor-pointer">Skirt</p>
          <p className="text-gray-500 cursor-pointer">One-Set</p>
          <p className="text-gray-500 cursor-pointer">T-Shirt</p>
        </div>
        <div className="flex flex-col gap-3 w-full mb-5 md:mb-0 md:w-1/4">
          <h2 className="tracking-wider mb-4 text-xl">Info</h2>
          <p className="text-gray-500">About</p>
          <p className="text-gray-500">yourstylistmyanmar.fashion@gmail.com</p>
        </div>

        <div className="flex flex-col gap-3 w-full mb-5 md:mb-0 md:w-1/4">
          <h2 className="tracking-wider mb-4 text-xl">Policy</h2>
          <Link to={paths.shipping}>
            <p className="text-gray-500 cursor-pointer">Shipping Policy</p>
          </Link>
        </div>
        <div className="flex flex-col gap-3 w-full mb-5 md:mb-0 md:w-1/4">
          <h2 className="tracking-wider mb-4 text-xl">Our Mission</h2>
          <p className="text-gray-500">
            Quality materials ,good designs , craftsmanship and sustainability
          </p>
        </div>
      </div>
      <div className="w-[90%] h-px bg-black mx-auto my-5 "></div>
      <div className="flex flex-col md:flex-row  gap-5 justify-between w-[90%] mx-auto ">
        {/* <LanguageDropdown /> */}
        <p className=" text-xs text-gray-500 order-2 md:order-1">
          CopyRight &copy; {`${new Date().getFullYear()} , YourStylist`}
        </p>
        <div className="flex gap-4 order-1 md:order-2">
          <FiFacebook className="cursor-pointer" />
          <FiInstagram className="cursor-pointer" />
          {/* <FiYoutube className="cursor-pointer" /> */}
          <FiTwitch className="cursor-pointer" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
